// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://nwweejpidselzqtwvgnb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im53d2VlanBpZHNlbHpxdHd2Z25iIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI5NDc5ODgsImV4cCI6MjA1ODUyMzk4OH0.ys35Bxn1zBgzOwLus_43SaNVU79fkpKtOMiHmYg0ekc";

// Regular client for public operations
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);

// Function to get an admin client with the proper headers
export const getAdminClient = () => {
  const authData = localStorage.getItem('admin_auth_data');
  if (!authData) return supabase;

  try {
    const { authenticated, sessionId } = JSON.parse(authData);
    if (!authenticated || !sessionId) return supabase;

    // Create a new client with admin headers
    return createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
      global: {
        headers: {
          'x-admin-session': sessionId
        }
      }
    });
  } catch (err) {
    console.error('Error creating admin client:', err);
    return supabase;
  }
};